<template>
  <b-form-group>
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text><i class="fa fa-search"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="text"
        placeholder=""
        v-model="filtro">
      </b-form-input>
      <b-input-group-append>
        <b-button variant="primary" @click="limparFiltro">Limpar</b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
  export default {
    name: 'app-filtro-tabela',
    data () {
      return {
        filtro: ''
      }
    },
    props: {
      value: {
        type: String || Number
      }
    },
    methods: {
      limparFiltro () {
        this.filtro = ''
      }
    },
    watch: {
      filtro () {
        this.$emit('input', this.filtro)
      }
    }
  }
</script>